import Logo from "../Logo";
import {H1} from "../Headlines";
import React from "react";
import Paragraph, {HeadlineParagraph} from "../Paragraph";
import Section from "./Section";

export default function Header() {
    return <>
        <Logo/>
        <HeadlineParagraph>Energetische Verbesserung Ihrer Immobilie</HeadlineParagraph>
        <Section id={'home'}>
            <H1 id={'omw-energieberatung'}>OMW Energieberatung</H1>
            <Paragraph className="mt-12">
                Das gesamte Team des OMW-Energieberatungsbüros hat es sich zur Aufgabe
                gemacht, die Energieberatung umfassend zu gestalten und passgenau auf die
                finanziellen Möglichkeiten unserer Kunden abzustimmen. Wir begleiten Sie bei jedem
                Schritt zur Modernisierung Ihres Gebäudes.
            </Paragraph>
            <Paragraph className="mt-8">
                Unser Team der OMW-Energieberatung freut sich auf <a href={'#kontakt'} className={'underline hover:text-gray-900'}>Ihre Kontaktanfrage</a>.
            </Paragraph>
        </Section>
    </>
}